<div class="card card-primary">
  <div class="card-header">
    {{ 'meetings.AgendaItems' | translate }}<span class="badge badge-secondary"
      *ngIf='!itemsLoading'>{{agendItems.length}}</span>
    <button class="btn add-btn" *ngIf='!itemsLoading && meeting.isOwner && agendaData.canAdd'
      (click)='agendaItemForm = true'>
      <svg width="14" height="14" viewBox="0 0 14 14">
        <path id="plus"
          d="M5.279,12.1V8.719H1.911A1.824,1.824,0,0,1,0,7,1.819,1.819,0,0,1,1.911,5.285H5.279V1.91A1.826,1.826,0,0,1,7,0,1.823,1.823,0,0,1,8.721,1.91V5.285h3.373A1.817,1.817,0,0,1,14,7a1.823,1.823,0,0,1-1.906,1.719H8.721V12.1A1.819,1.819,0,0,1,7,14,1.822,1.822,0,0,1,5.279,12.1Z"
          fill="#fff" opacity="0.9" />
      </svg>
    </button>
  </div>
  <div class="card-body p-0">
    <div *ngIf='itemsLoading' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-container *ngIf='!itemsLoading'>
      <div class="agenda-list">
        <div cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor='let item of agendItems; let i = index;' cdkDrag [cdkDragDisabled]="!item.canEdit">
            <div class="agenda-item" [ngClass]="{'case no-bg d-block': item.madicalCases}" >

              <ng-container *ngIf="!item.madicalCases">
                <div class="title">
                  <span class="drag-me mr-3" cdkDragHandle *ngIf="item.canEdit">
                    <img src="./assets/images/icons/drag-drop-icon.svg" alt="">
                  </span>
                  <span class="badge badge-secondary">{{i+1}}</span>
                  <h3>{{item.title}}</h3>

                  <div class="d-inline-block tableOptions-container">
                    <button class="btn open-link" (click)='openAgendaItem(item)' *ngIf='meeting.isOwner && agendaData.canViewDetails'>
                      <svg width="14" height="14" viewBox="0 0 14 14">
                        <path id="expand-sub-task-icon"
                          d="M-13.307-18.75v1.568h2.771l-7.62,7.62,1.094,1.094,7.62-7.62v2.771h1.568V-18.75ZM-9.443-6.318H-20.307V-17.182h3.939V-18.75h-3.939a1.5,1.5,0,0,0-1.13.456,1.546,1.546,0,0,0-.437,1.112V-6.318a1.513,1.513,0,0,0,.456,1.112,1.513,1.513,0,0,0,1.112.456H-9.443a1.513,1.513,0,0,0,1.112-.456,1.513,1.513,0,0,0,.456-1.112v-3.939H-9.443Z"
                          transform="translate(21.875 18.75)" fill="#71a2bc" />
                      </svg>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="item.madicalCases">
                <div class="d-flex align-items-start">
                  <span class="drag-me mr-3" cdkDragHandle *ngIf="item.canEdit">
                    <img src="./assets/images/icons/drag-drop-icon.svg" alt="">
                  </span>

                  <div class="title">
                    <span class="badge badge-secondary">{{i+1}}</span>
                  </div>
                  <div class="case-details">
                    <div class="d-flex align-items-center">
                      <span class="badge blue large"><span>{{'case.MRN' | translate}}:</span>{{item.madicalCases.mrn}}</span>
                      <span class="sep">|</span>
                      <span class="span-info">{{item.madicalCases.diagnosis}}</span>
                      <ng-container *ngIf="!liveView">
                        <span class="sep">|</span>
                        <div class="referred-from">
                          <p>{{ 'agendaCase.Referred from' | translate }}: <b>{{item.madicalCases.referredFrom}}</b></p>
                        </div>
                      </ng-container>
                    </div>
                    <div>
                      <h2>{{item.madicalCases.pationtName}}</h2>
                    </div>
                  </div>

                  <div class="d-inline-block tableOptions-container">
                    <button class="btn open-link" (click)='openAgendaItem(item)' *ngIf="liveView">
                      <svg width="14" height="14" viewBox="0 0 14 14">
                        <path id="expand-sub-task-icon"
                          d="M-13.307-18.75v1.568h2.771l-7.62,7.62,1.094,1.094,7.62-7.62v2.771h1.568V-18.75ZM-9.443-6.318H-20.307V-17.182h3.939V-18.75h-3.939a1.5,1.5,0,0,0-1.13.456,1.546,1.546,0,0,0-.437,1.112V-6.318a1.513,1.513,0,0,0,.456,1.112,1.513,1.513,0,0,0,1.112.456H-9.443a1.513,1.513,0,0,0,1.112-.456,1.513,1.513,0,0,0,.456-1.112v-3.939H-9.443Z"
                          transform="translate(21.875 18.75)" fill="#71a2bc" />
                      </svg>
                    </button>
                    <a class="btn open-link" *ngIf="!liveView"
                      [routerLink]="['/admin/meetings/caseDetails', meeting.meetingId, item.agendaItemEntityId]">
                      <svg width="14" height="14" viewBox="0 0 14 14">
                        <path id="expand-sub-task-icon"
                          d="M-13.307-18.75v1.568h2.771l-7.62,7.62,1.094,1.094,7.62-7.62v2.771h1.568V-18.75ZM-9.443-6.318H-20.307V-17.182h3.939V-18.75h-3.939a1.5,1.5,0,0,0-1.13.456,1.546,1.546,0,0,0-.437,1.112V-6.318a1.513,1.513,0,0,0,.456,1.112,1.513,1.513,0,0,0,1.112.456H-9.443a1.513,1.513,0,0,0,1.112-.456,1.513,1.513,0,0,0,.456-1.112v-3.939H-9.443Z"
                          transform="translate(21.875 18.75)" fill="#71a2bc" />
                      </svg>
                    </a>
                  </div>
                </div>
              </ng-container>

              <div class="mt-3" *ngIf="item.attachments.length">
                <app-files-viewer [files]='item.attachments' [meetingId]="meeting.meetingId"></app-files-viewer>
              </div>

              <ng-container *ngIf='!meeting.isOwner'>
                <!-- Answers -->
                <div class="mt-3" *ngIf='item.attendeeVotingAnswers.length'>
                  <h6>{{ 'meetings.Question' | translate }}: {{item.votingModel.title}}</h6>
                  <div class="mt-3" *ngFor='let answer of item.attendeeVotingAnswers'>
                    <div class="name-with-image small" *ngIf="answer.creator && answer.creator.creatorId">
                      <div class="image-circle" [title]="answer.creator.creatorName">
                        <img *ngIf="answer.creator.creatorProfilePicture" [src]="answer.creator.creatorProfilePicture"
                          (error)="answer.creator.creatorProfilePicture = ''" />
                        <span *ngIf="!answer.creator.creatorProfilePicture">{{ answer.creator.creatorName | shortName }}</span>
                      </div>
                      <div class="name">
                        <h5>{{answer.creator.creatorName}}<span>({{answer.creator.creatorUserName}})</span></h5>
                        <h6>{{answer.creator.creatorCollectionName}}</h6>
                      </div>
                      <div class="delegated-user" *ngIf="answer.delegator && answer.delegator.creatorId">
                        <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                        <div class="image-circle" [title]="answer.delegator.creatorName">
                          <img *ngIf="answer.delegator.creatorProfilePicture" [src]="answer.delegator.creatorProfilePicture"
                            (error)="answer.delegator.creatorProfilePicture = ''" />
                          <span *ngIf="!answer.delegator.creatorProfilePicture">{{ answer.delegator.creatorName | shortName
                            }}</span>
                        </div>
                        <div class="creatorName pl-2" *ngIf="answer.delegator.creatorName">
                          ({{answer.delegator.creatorName}})
                        </div>
                      </div>
                    </div>
                    <div class="pt-2 pl-5 ml-2"
                      [ngClass]="{'has-delegator': answer.delegator && answer.delegator.creatorId, 'isLiveView': liveView}">
                      <p>{{ 'meetings.Answer' | translate }}: {{answer.answer}}</p>
                    </div>
                  </div>
                </div>

                <!-- Comments -->
                <div class="mt-3" *ngIf='showCommentPanel !== i && item.commentAsWho.length'>
                  <button class="btn btn-gery" (click)='showCommentArea(i)'> {{ 'meetings.AddComment' | translate
                    }}</button>
                </div>
                <div class="comments-container" *ngIf='showCommentPanel == i || item.comments.pageData.length'>
                  <div class="comment-panel" *ngIf='showCommentPanel == i && item.commentAsWho.length'>
                    <div class="comment-form" [ngClass]="{'isLiveView': liveView}">
                      <div class="name-with-image">
                        <div class="image-circle" [title]="currentUser.name">
                          <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                            (error)="currentUser.profilePicture = ''" />
                          <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
                        </div>
                      </div>
                      <div class="comment-control">
                        <div class="d-flex mb-2">
                          <span class="mr-2">{{ 'general.As' | translate }}:</span>
                          <div>
                            <mat-form-field class="comment-as no-validation">
                              <mat-select [(ngModel)]="commentAs">
                                <mat-option *ngFor="let user of item.commentAsWho" [value]="user">
                                  <!-- <img class="example-option-img" height="25"
                                                                  *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                  (error)="user.profilePhoto = ''" />
                                                              <span class="example-option-img" *ngIf="!user.profilePhoto">{{ user.fullName | shortName }}</span> -->
                                  <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <mat-form-field class="no-validation">
                          <textarea matInput maxlength="1000" #comment [(ngModel)]="myComment"
                            (keyup)="textAreaAdjust($event);"
                            [placeholder]="'messagesCom.Type your comment here' | translate"></textarea>
                        </mat-form-field>
                        <div class="btn-container">
                          <button *ngIf="trim(myComment) != ''" class="btn customBtn" [ngClass]="{loading: commentLoader}"
                            (click)="addMyComment(item.agendaItemEntityId)">{{ 'messagesCom.AddComment' | translate
                            }}</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="comments-list comment-panel meeting-panel" *ngIf='item.comments.pageData.length'>
                    <div class="comment-form" *ngFor='let comment of item.comments.pageData'
                      [ngClass]="{'isLiveView': liveView}">
                      <div class="name-with-date" *ngIf="comment.creatorData.creatorId">
                        <div class="name-with-image">
                          <div class="image-circle" [title]="comment.creatorData.creatorName">
                            <img *ngIf="comment.creatorData.creatorProfilePicture"
                              [src]="comment.creatorData.creatorProfilePicture"
                              (error)="comment.creatorData.creatorProfilePicture = ''" />
                            <span *ngIf="!comment.creatorData.creatorProfilePicture">
                              {{ comment.creatorData.creatorName | shortName }}</span>
                          </div>
                          <img class="delegated-icon" src="./assets/images/icons/delegated.svg"
                            *ngIf="comment.delegatorData.creatorId">
                          <div class="creatorName pl-2">
                            ({{comment.creatorData.creatorName}})
                          </div>
                        </div>
                        <div class="reply-actions">
                          <span class="date-time">{{comment.created | date:'longDate'}}</span>
                        </div>
                      </div>

                      <div class="name-with-date" *ngIf="comment.delegatorData.creatorId"
                        [ngClass]="{'delegator-user': comment.delegatorData.creatorId}">
                        <div class="name-with-image">
                          <div class="image-circle" [title]="comment.delegatorData.creatorName">
                            <img *ngIf="comment.delegatorData.creatorProfilePicture"
                              [src]="comment.delegatorData.creatorProfilePicture"
                              (error)="comment.delegatorData.creatorProfilePicture = ''" />
                            <span *ngIf="!comment.delegatorData.creatorProfilePicture">
                              {{ comment.delegatorData.creatorName | shortName }}</span>
                          </div>
                          <div class="creatorName pl-2" *ngIf="comment.delegatorData.creatorName">
                            ({{comment.delegatorData.creatorName}})
                          </div>
                        </div>
                        <div class="reply-actions">
                          <span class="date-time">{{comment.created | date:'longDate'}}</span>
                        </div>
                      </div>

                      <div class="comment-control">

                        <p *ngIf='showEditPanel !== comment.commentId' class="replay"
                          [ngClass]="{'delegator-comment': comment.delegatorData.creatorId}">{{comment.content}}</p>
                        <ng-container *ngIf='showEditPanel == comment.commentId'>
                          <mat-form-field class="no-validation mt-1">
                            <textarea matInput maxlength="1000" [(ngModel)]="comment.content"
                              (keyup)="textAreaAdjust($event);" [placeholder]="comment.content"></textarea>
                          </mat-form-field>
                          <div class="btn-container">
                            <button *ngIf="trim(comment.content) != ''" class="btn customBtn"
                              [ngClass]="{loading: replyLoader}" (click)="editComment(comment)">{{ 'messagesCom.Edit' |
                              translate }}</button>
                          </div>
                        </ng-container>

                      </div>
                    </div>

                  </div>
                </div>

                <div class="mt-4" *ngIf="item.recommendationList.length && item.showRecommendation">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 class="main-title"> {{ 'meetings.Recommendations' | translate }}</h4>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="recommendations">
                        <div class="items-list-container">
                          <div class="items-list">
                            <div>
                              <div *ngFor="let listItem of item.recommendationList; index as i;" class="terms-control">
                                <span class="list-icon">
                                  <svg width="14" height="14" viewBox="0 0 14 14">
                                    <path id="listing-icon"
                                      d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                                      fill="#aaa" />
                                  </svg>
                                </span>
                                <div>
                                  <div class="form-control">{{listItem.title}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>

              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal fade votingModal" tabindex="-1" role="dialog" *ngIf="showvotingModal && liveView"
  [ngClass]="{show: showvotingModal}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"> {{ 'meetings.Voting' | translate }}</h4>

        <!-- <button type="button" class="close"
              aria-label="Close"
              *ngIf='!votingAgendaItem.allowedVoting'
              (click)="closePop()">
              <span>&times;</span>
          </button> -->
      </div>

      <div class="modal-body">
        <h3>{{votingAgendaItem.title}}</h3>
        <div class="timer py-2" *ngIf="votingAgendaItem.votingModel.votingHasTime">
          <countdown #cd [config]="{ leftTime: (votingAgendaItem.votingModel.votingRemainingTime*60), format: 'mm:ss' }"
            (event)="timesUp($event)"> </countdown>
        </div>

        <form>
          <div class="d-flex mb-3" *ngIf="votingAgendaItem.voteAsWho.length">
            <span class="mr-2">{{ 'general.As' | translate }}:</span>
            <div>
              <mat-form-field class="comment-as no-validation">
                <mat-select [(ngModel)]="voteAs" [ngModelOptions]="{standalone: true}">
                  <mat-option *ngFor="let user of votingAgendaItem.voteAsWho" [value]="user">
                    <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <p class="quest-text">{{questionTitle}}</p>
          <div class="questionWithOptions" *ngIf="questionType == 1 || questionType == 2">
            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
              [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}">
              <mat-radio-button class="example-radio-button" *ngFor="let questionOption of questionOptions"
                [value]="questionOption.votingOptionId">
                {{questionOption.title}}
              </mat-radio-button>
            </mat-radio-group>
            <p class="has-error mt-3" *ngIf="!selectedOption && noSelected"> {{ 'meetings.pleasechoiceAnswer' |
              translate }}</p>
          </div>
          <div class="questionWithoutOptions" *ngIf="questionType == 0">
            <textarea [placeholder]="'meetings.Your Answer' | translate" class="form-control"
              [(ngModel)]="questionAnswer" [ngModelOptions]="{standalone: true}" maxlength="300"></textarea>
            <p class="has-error mt-3" *ngIf="!questionAnswer && noAnswer"> {{ 'meetings.pleaseEnterAnswer' | translate
              }}</p>
          </div>
          <div class="modal-btns">
            <!-- <button type="reset" class="close closebtn" aria-label="Close" (click)="closePop()">
                     Cancel
                  </button> -->
            <button mat-raised-button class="btn customBtn" (click)="saveVotingItem()" [disabled]="loading"
              [ngClass]="{ 'loading': loading }">
              {{ 'meetings.vote' | translate }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
<!-- new updates -->
<app-agenda-item *ngIf="openItemModal && selectedAgendaItem && selectedAgendaItem.agendaItemEntityId"
  [meeting]='meeting' [liveView]='liveView' [item]='selectedAgendaItem' [agendaItemsCount]='agendItems.length'
  (cancelPop)='closeAgendaItem()'></app-agenda-item>

<app-agenda-form [meetingId]='meeting.meetingId' [itemsCount]='agendItems.length' (cancelPop)='agendaItemForm = false' [item]='selectedAgendaItem'
  (closePopAndSave)='saveItemSucsses()' *ngIf="agendaItemForm"></app-agenda-form>

<div class="current-voting" *ngIf="liveView && isShow">
  <div (click)="openCurrentVote(true)">
    current voting
  </div>
</div>
